import React from 'react';
import { Box } from '@mui/material';
import CustomButton from '../Button/customButton/CustomButton';
import styles from './style.module.scss';

const AppCard = ({
    header,
    description,
    icon,
    showButton = false,
    buttonText,
    onButtonClick,
    buttonVariant = 'outlined',
    children,
    toggleButton,
}) => {
    return (
        <Box className={styles.appCard}>
            <Box className={styles.topSection}>
                {icon && (
                    <Box className={styles.iconWrapper}>
                        {typeof icon === 'string' ? (
                            <img src={icon} alt={header || 'App'} />
                        ) : (
                            icon
                        )}
                    </Box>
                )}
                <Box className={styles.contentRight}>
                    <h3 className={styles.header}>{header}</h3>
                </Box>
                {toggleButton && (
                    <Box className={styles.toggleWrapper}>
                        {toggleButton}
                    </Box>
                )}
            </Box>
            {description && <p className={styles.description}>{description}</p>}
            <hr className={styles.separator} />
            {showButton && <Box className={styles.bottomSection}>
                {buttonText && (
                    <CustomButton
                        variant={buttonVariant}
                        onClick={onButtonClick}
                    >
                        {buttonText}
                    </CustomButton>
                )}
                {children}
            </Box>}
        </Box>
    );
};

export default AppCard;
